module.exports = __webpack_public_path__ + "img/upgrade.d09816a1.svg";